import { render, staticRenderFns } from "./dialogAddDonors.vue?vue&type=template&id=76ced598"
import script from "./dialogAddDonors.vue?vue&type=script&lang=js"
export * from "./dialogAddDonors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports